import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import * as turf from '@turf/turf';
import classNames from 'classnames/bind';
import { Draw } from 'ol/interaction';
import { toLonLat } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import React, { useMemo } from 'react';
import { RiShapeLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import { FENCE_POLYGON_AREA_MIN } from '@/config';
import { STYLES } from '@/define/olMaps';
import OlMap from '@/helpers/OlMap';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import { NotifierService as notifier } from '@/libs/Notifier';
import CoordUtils from '@/utils/CoordUtils';
const cx = classNames.bind(styles);

const DrawPolygon = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'fence/polygon';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    const interaction = new Draw({
      source: new VectorSource({ wrapX: false }),
      type: 'Polygon',
      freehand: false,
      style: STYLES.MISSION.FENCE,
    });
    interaction.on('drawend', drawPolygon);
    map.addInteraction(interaction);

    return () => {
      map.removeInteraction(interaction);
    };
  }, [pressed]);

  const drawPolygon = (e) => {
    const coords = e.feature.getGeometry().getCoordinates()[0];
    const polygon = turf.polygon([coords.map((coord) => toLonLat(coord))]);

    const selfIntersections = turf.kinks(polygon).features;
    // 자기교차점 존재 시
    if (selfIntersections.length > 0) {
      notifier.error('The drawn polygon cannot have self-intersections. Please redraw.');
      return;
    }

    const area = turf.area(polygon);
    // 면적 100m² 미만 시
    if (area < FENCE_POLYGON_AREA_MIN) {
      notifier.error(`The fence area cannot be smaller than ${FENCE_POLYGON_AREA_MIN}m². Please redraw.`);
      return;
    }

    const boundary = coords.map((coord) => {
      return CoordUtils.objectFromArray(toLonLat(coord));
    });

    dispatch(actions.mission.mavlink.addFence('Polygon', { boundary }));
    dispatch(actions.editor.changeMode(null));
  };

  const toggle = () => {
    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('fence/polygon'));
    }
  };

  return (
    <div className={cx('container')}>
      <div className={cx(['button', { pressed }])} onClick={handleWithMoveCheck(toggle)}>
        <RiShapeLine size={20} />
        <div className={cx('label')}>Polygon</div>
      </div>
    </div>
  );
};

export default DrawPolygon;
